'use client'

import Image from 'next/image'
import { useState } from 'react'

export default function FeedbackBanner({
  surveyUrl = 'https://surveidigital.spbe.go.id/embed/survey/eyJzdXJ2ZXlfaWQiOjIsInNlcnZpY2VfaWQiOjM0OSwiaG9zdCI6Imh0dHBzOi8vdWx0LmtlbWVuZGlrZGFzbWVuLmdvLmlkLyxodHRwczovL3VsdC5hdW0uc3RhZ2luZy5iZWxhamFyLmlkLyxodHRwOi8vbG9jYWxob3N0OjMwMDAvLGh0dHBzOi8vcHVzYXRpbmZvcm1hc2kudWx0LmtlbWVuZGlrZGFzbWVuLmdvLmlkLyIsImtleSI6ImVvbzVXMzVaIn0=/embed/view/?jenis_layanan=Website ULT - Lacak Status Tiket Laporan', // Link default survei
}) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      {/* ========================================= */}
      {/* BANNER PENILAIAN */}
      {/* ========================================= */}
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between bg-white border border-blue-100 border-l-[4px] border-l-[#1e3a8a] rounded-lg shadow-sm gap-4 py-5 mx-auto my-[56px] md:my-[80px] px-4 lg:px-8 w-full max-w-5xl">
        {/* Bagian Kiri (Ikon & Teks) */}
        <div className="flex items-start gap-4 px-4 lg:px-0">
          <div className="flex-shrink-0 bg-[#f4f7fb] p-3 rounded-full mt-1 md:mt-0">
            <Image
              src="/images/icon-chat.svg"
              alt="Ikon Chat"
              width={24}
              height={24}
              className="w-6 h-6 object-contain"
            />
          </div>

          <div>
            <p className="text-[10px] md:text-xs font-bold text-gray-400 uppercase tracking-wider mb-1">
              Bantu Kami Berkembang
            </p>
            <h4 className="text-base font-bold text-gray-800 mb-1">
              Bagaimana pengalaman Anda menggunakan layanan ini?
            </h4>
            <p className="text-sm text-gray-500">
              Ceritakan pengalaman Anda — masukan Anda membantu kami terus
              meningkatkan layanan.
            </p>
          </div>
        </div>

        {/* Bagian Kanan (Tombol) */}
        <div className="flex-shrink-0 mt-3 md:mt-0 md:self-center w-full md:w-auto px-4 lg:px-0">
          <button
            onClick={() => setIsModalOpen(true)}
            className="flex w-full md:w-auto items-center justify-center gap-2 px-5 py-2.5 bg-white border border-gray-300 rounded-md text-gray-700 font-medium text-sm hover:bg-azure hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <Image
              src="/images/icon-star.svg"
              alt="Ikon Bintang"
              width={20}
              height={20}
              className="w-5 h-5 object-contain"
            />
            Beri Penilaian
          </button>
        </div>
      </div>

      {/* ========================================= */}
      {/* Pop-up Modal Survei */}
      {/* ========================================= */}
      {isModalOpen && (
        <div
          className="fixed inset-0 z-[1000] flex items-center justify-center"
          onClick={() => setIsModalOpen(false)}
        >
          <div
            className="relative flex flex-col w-[90%] max-w-4xl h-[80%] max-h-[700px] bg-white p-5 text-center rounded-lg shadow-2xl border"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute right-5 top-4 text-gray-400 hover:text-black text-3xl font-bold leading-none transition-colors duration-200"
              onClick={() => setIsModalOpen(false)}
              aria-label="Tutup"
            >
              &times;
            </button>

            <h3 className="mb-5 mt-2.5 text-xl font-bold text-gray-800">
              Survei Layanan
            </h3>

            <iframe
              id="resultIframe"
              src={surveyUrl}
              className="w-full h-[85%] min-h-[400px] border-none rounded-lg"
              title="Survei Penilaian"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      )}
    </>
  )
}
